import { render, staticRenderFns } from "./RecipeForm.vue?vue&type=template&id=35e639b3&"
import script from "./RecipeForm.vue?vue&type=script&lang=js&"
export * from "./RecipeForm.vue?vue&type=script&lang=js&"
import style0 from "./RecipeForm.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports